import i18n from "@/plugins/i18n";
import router from "@/router";
import moment from "moment";

var formatNumber = {
  separador: ",", // separador para los miles
  sepDecimal: ".", // separador para los decimales
  formatear: function (num) {
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
    }
    return splitLeft + splitRight + " " + this.simbol;
  },
  new: function (num, simbol) {
    this.simbol = simbol || "";
    return this.formatear(num);
  },
};

var splitTimeFunction = {
  splitFunction: function (time) {
    var Days = Math.floor(time / 24);
    var Remainder = time % 24;
    var Hours = Math.floor(Remainder);
    var rest = Remainder - Hours;
    var Minutes = rest > 0 ? Math.round(60 * rest) : 0;

    var daysFinal = "";
    var minsFinal = "";
    var hoursFinal = "";

    if (router.app.$route.path == "/dashboard/performance") {
      if (Days > 0) {
        daysFinal = Days > 9 ? Days + "D, " : "0" + Days + "D, ";
      }
      hoursFinal = Hours > 9 ? Hours + ":" : "0" + Hours + ":";
      minsFinal = Minutes > 9 ? Minutes : "0" + Minutes;
    } else {
      if (Days > 0) {
        daysFinal = Days > 9 ? Days + "D, " : "0" + Days + "D, ";
        hoursFinal = Hours > 9 ? Hours + ":" : "0" + Hours + ":";
        minsFinal = Minutes > 9 ? Minutes : "0" + Minutes;
      } else {
        hoursFinal = Hours > 9 ? Hours + " H, " : "0" + Hours + " H, ";
        minsFinal = Minutes > 9 ? Minutes + " min" : "0" + Minutes + " min";
      }
    }

    var splitTimeFinal = daysFinal + hoursFinal + minsFinal;
    return splitTimeFinal;
  },
};

export default {
  getSelectedAccess: (state) => (id) => {
    return state.multipleUserData.map((item) => item.AccessId == id);
  },
  getBlobsForDownload: (state) => (blob) => {
    var data = [];
    blob.map((item) => {
      if (item.urlBlob.length > 0) data.push(item);
    });
    return data;
  },
  OrderBy: (state) => (payload) => {
    var format = [];
    if (payload.length > 0) {
      var shorted = payload.sort(function compare(a, b) {
        if (a.Name < b.Name) return -1;
        if (a.Name > b.Name) return 1;
        return 0;
      });

      shorted.forEach((element) => {
        var formantReplace = element.Name.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
        element.Name = formantReplace;
        format.push(element);
      });
    }
    return format;
  },
  getAccessFilter: (state) => (payload) => {
    var arrAccess = payload[0];
    var result = {};
    if (arrAccess.length > 0) {
      arrAccess.map((item) => {
        if (payload[2] == "DealerId")
          if (item != i18n.t("all") && item.DealerId == payload[1])
            result = item;
        if (payload[2] == "ClientId")
          if (item != i18n.t("all") && item.ClientId == payload[1])
            result = item;
        if (payload[2] == "AccountId")
          if (item != i18n.t("all") && item.AccountId == payload[1])
            result = item;
        if (payload[2] == "GroupId")
          if (item != i18n.t("all") && item.GroupId == payload[1])
            result = item;
      });
    }
    return result;
  },
  listOfVehicles: (state) => (payload) => {
    var listOfVehicles = [];
    if (payload.length > 0) {
      payload.map((item) => {
        return listOfVehicles.push(item.MovilId);
      });
    }

    return listOfVehicles;
  },
  GetMetrics: (state) => {
    var metrics = [];
    state.ItemsColums.map((item) => {
      if (item.value <= 16) return metrics.push(item.value);
    });
    return metrics;
  },
  getTime: (state) => (payload) => {
    var dt = "";
    if (payload == "start") {
      dt = moment(state.startTimeH, ["h:mm A"]).format("HH:mm");
    } else {
      dt = moment(state.endTimeH, ["h:mm A"]).format("HH:mm");
    }

    return dt;
  },
  getTime2: (state) => (payload) => {
    var dt = "";
    if (payload == "start") {
      //  console.log(state.startTimeH2);
      dt = moment(state.startTimeH2, ["h:mm A"]).format("HH:mm a");
    } else {
      // console.log(state.endTimeH2);
      dt = moment(state.endTimeH2, ["h:mm A"]).format("HH:mm a");
    }

    return dt;
  },
  genericChart: (state) => (payload) => {
    var genericChart = JSON.parse(
      JSON.stringify(state.ChartVehiclesExceptions)
    );

    genericChart.title.text = payload[0];
    genericChart.yAxis.title = payload[1];
    genericChart.plotOptions.column.color = payload[2];
    genericChart.tooltip.pointFormat = payload[3];
    genericChart.series[0].name = payload[4];
    genericChart.series[0].data = payload[5];
    genericChart.xAxis.categories = payload[6];
    genericChart.plotOptions.column.stacking = payload[7];
    genericChart.chart.renderTo = payload[8];
    genericChart.subtitle.text = payload[9] == undefined ? "" : payload[9];
    //genericChart.plotOptions.column.dataLabels.format = payload[10];

    try {
      var chart = payload[4];
      var unit = "";
      var vol =
        localStorage.getItem("Volume") == undefined
          ? "L"
          : localStorage.getItem("Volume");
      var distanc =
        localStorage.getItem("Distance") == undefined
          ? "Km"
          : localStorage.getItem("Distance");
      if (chart == i18n.t("rendimientoFuel")) {
        //|| "Rendimiento" || "Tiempo con motor encendido"
        unit = " " + distanc + "/" + vol;
      } else if (chart == "Ralentifuel") {
        // || chart == "Ralentifuel"
        unit = " " + vol;
      } else if (chart != i18n.t("timeEngineOn")) {
      }
      genericChart.plotOptions.column.dataLabels.formatter = function () {
        var dataTooltip = formatNumber.new(this.point.y, unit);
        if (chart == i18n.t("timeEngineOn")) {
          dataTooltip = splitTimeFunction.splitFunction(this.point.y);
        }
        return dataTooltip;
      };
      genericChart.tooltip = {
        formatter: function () {
          var dataTooltip = formatNumber.new(this.point.y, unit);
          if (chart == i18n.t("timeEngineOn")) {
            dataTooltip = splitTimeFunction.splitFunction(this.point.y);
          }
          var series = this.point.series.chart.series, // get all series
            index = this.point.series.xData.indexOf(this.point.x), // get index
            str =
              "<b>" +
              this.point.category + //id //color
              "</b>" +
              " <br>" +
              "<span style='color: " +
              this.point.color +
              "  ' >Id: </span>" +
              this.point.id +
              "<br>" +
              "<span style='color: " +
              this.point.color +
              "  ' >Total: </span>" +
              dataTooltip;
          return str;
        },
      };
    } catch (e) {
      console.log(e);
    }
    return genericChart;
  },
  trafficChart: (state) => (payload) => {
    var trafficChart = JSON.parse(JSON.stringify(state.ChartTraffic));

    trafficChart.title.text = payload[0];
    trafficChart.yAxis.title.text = payload[1];
    trafficChart.plotOptions.bar.color = payload[2];
    trafficChart.tooltip.pointFormat = payload[3];
    trafficChart.series[0].name = payload[4];
    trafficChart.series[0].data = payload[5];
    trafficChart.xAxis.categories = payload[6];
    trafficChart.plotOptions.bar.stacking = payload[7];
    trafficChart.chart.renderTo = payload[8];
    trafficChart.subtitle.text = payload[9] == undefined ? "" : payload[9];
    trafficChart.plotOptions.bar.dataLabels.format = payload[10];

    trafficChart.tooltip.headerFormat = payload[11];
    return trafficChart;
  },
  pieGenericChart: (state) => (payload) => {
    var vm = this;
    var pieCharts = JSON.parse(JSON.stringify(state.PieChartOptions));
    pieCharts.title.text = payload[0];
    pieCharts.series[0].data = payload[1];

    pieCharts.legend.x = payload[2];
    pieCharts.legend.align = payload[3];
    pieCharts.legend.itemDistance = payload[4];
    pieCharts.legend.itemStyle.fontSize = payload[5];
    pieCharts.chart.renderTo = payload[6];
    pieCharts.series[0].name = payload[7];
    pieCharts.subtitle.text = payload[8];

    pieCharts.tooltip = {
      borderWidth: 0,
      backgroundColor: "rgba(219,219,216,0.8)",
      shadow: false,
      style: {
        color: "#000",
      },
      formatter: function () {
        var chart = payload[6];
        var unit = "";
        var vol =
          localStorage.getItem("Volume") == undefined
            ? "L"
            : localStorage.getItem("Volume");
        var distanc =
          localStorage.getItem("Distance") == undefined
            ? "Km"
            : localStorage.getItem("Distance");

        if (chart == "FuelRange") {
          chart = i18n.t("rangeFuel");
          unit = " " + distanc + "/" + vol;
        } else if (chart == "fuelUsed") {
          chart = i18n.t("usedfuel");
          unit = " " + vol;
        } else if (chart != "EngineOn") {
          chart = i18n.t("exceptions");
        }

        var dataTooltip = formatNumber.new(this.point.y, unit);

        if (chart == "EngineOn") {
          chart = i18n.t("engineTime");
          dataTooltip = splitTimeFunction.splitFunction(this.point.y);
        }

        var series = this.point.series.chart.series, // get all series
          index = this.point.series.xData.indexOf(this.point.x), // get index
          str =
            this.point.name +
            " <br>" +
            this.point.percentage.toFixed(2) +
            " %<br> Total: " +
            dataTooltip;
        str = "<p><b>" + chart + "</b></p>" + ": <br><br>" + str;
        return str;
      },
    };

    pieCharts.series[0].point = {
      events: {
        click: function (event) {
          var chart = payload[6];

          if (
            chart == "FuelRange" ||
            chart == "fuelUsed" ||
            chart == "EngineOn"
          ) {
            localStorage.setItem("mytitle", JSON.stringify(chart));
            router.push({ name: "performance" });
          } else {
            router.push({ name: "inTransitIncidents" });
          }
        },
      },
    };

    return pieCharts;
  },
  charFillsimple: (state) => (payload) => {
    var chartFill = JSON.parse(JSON.stringify(state.ChartStackedOptiones));
    chartFill.title.text = payload[0];
    chartFill.yAxis.title = payload[1];
    chartFill.series[0].name = payload[2];
    chartFill.series[0].data = payload[3];
    chartFill.xAxis.categories = payload[4];
    chartFill.chart.renderTo = payload[5];
    chartFill.chart.scrollablePlotArea.minWidth = payload[6];
    chartFill.colors = payload[7];
    chartFill.tooltip.pointFormat = payload[8];
    return chartFill;
  },
  charFillmultiple: (state) => (payload) => {
    var chartFill = JSON.parse(JSON.stringify(state.ChartStackedOptiones));
    chartFill.title.text = payload[0];
    chartFill.yAxis.title = payload[1];
    chartFill.series[0].name = payload[2];
    chartFill.series[0].data = payload[3];
    chartFill.series[1].name = payload[4];
    chartFill.series[1].data = payload[5];
    chartFill.xAxis.categories = payload[6];
    chartFill.chart.renderTo = payload[7];
    chartFill.chart.scrollablePlotArea.minWidth = payload[8];
    chartFill.colors = payload[9];
    chartFill.tooltip.pointFormat = payload[10];
    return chartFill;
  },
  changeUnits: (state) => (payload) => {
    var arr = payload;
    var newarr = [];
    var SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    arr.forEach((element) => {
      if (SelectedVolume == "L") {
        newarr.push(parseFloat(element));
      } else {
        var gal = parseFloat(element / 3.78541).toFixed(1);
        gal = Number(gal);
        newarr.push(gal);
      }
    });
    return newarr;
  },
  changeUnitsfuelUsed: (state) => (payload) => {
    var arr = [];
    var element1 = payload[0];
    var element2 = payload[1];
    var element3 = payload[2];

    var selectedVolume = localStorage.getItem("Volume");
    var vol = selectedVolume == undefined ? "L" : selectedVolume;

    if (vol != "L") {
      if (element1[1] > 0) {
        element1[1] = Number(parseFloat(element1[1] / 3.78541).toFixed(1));
        arr.push(element1);
      }

      if (element2[1] > 0) {
        element2[1] = Number(parseFloat(element2[1] / 3.78541).toFixed(1));
        arr.push(element2);
      }

      if (element3[1] > 0) {
        element3[1] = Number(parseFloat(element3[1] / 3.78541).toFixed(1));
        arr.push(element3);
      }
    } else {
      if (element1[1] > 0) {
        arr.push(payload[0]);
      }
      if (element2[1] > 0) {
        arr.push(payload[1]);
      }
      if (element3[1] > 0) {
        arr.push(payload[2]);
      }
    }

    return arr;
  },
  changeUnitsDistance: (state) => (payload) => {
    var arr = payload;
    var newarr = [];
    var SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    arr.forEach((element) => {
      if (SelectedDistance == "Km") {
        newarr.push(parseFloat(element));
      } else {
        var mi = parseFloat(element / 1.60934).toFixed(3);
        mi = Number(mi);
        newarr.push(mi);
      }
    });
    return newarr;
  },
  changeUnitsPerformance: (state) => (payload) => {
    var arr = payload;
    var newarr = [];
    var SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    var SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    arr.forEach((element) => {
      if (SelectedDistance == "Km" && SelectedVolume == "L") {
        newarr.push(parseFloat(element));
      } else {
        if (SelectedDistance == "Km" && SelectedVolume == "gal") {
          var kmgal = parseFloat(element * 4.54).toFixed(2);
          kmgal = Number(kmgal);
          newarr.push(kmgal);
        } else {
          if (SelectedDistance == "mi" && SelectedVolume == "L") {
            var miL = parseFloat(element * 0.62).toFixed(2);
            miL = Number(miL);
            newarr.push(miL);
          } else {
            var migal = parseFloat(element * 2.35).toFixed(2);
            migal = Number(migal);
            newarr.push(migal);
          }
        }
      }
    });
    return newarr;
  },
  getValues: (state) => (arr) => {
    var newarr = [];
    arr.map((item) => {
      newarr.push(item.Value);
    });
    return newarr;
  },
  getKeys: (state) => (arr) => {
    var newarr = [];
    arr.map((item) => {
      newarr.push(item.Key);
    });
    return newarr;
  },
  //changes
  getArr: (state) => (arr) => {
    var vol =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    var distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    var v_list = JSON.parse(localStorage.getItem("v_list"));

    var newarr = [];
    if (arr != null && arr.length > 1 && arr[0] != null) {
      arr[0].map((item) => {
        const vehicle = v_list.find(({ MovilId }) => MovilId === item.Key);
        var data = item.Value;
        if (arr[1] === 0) {
          if (vol != "L") {
            data = Number(parseFloat(item.Value / 3.78541).toFixed(1));
          }
        }
        if (arr[1] === 1) {
          if (vol == "L" && distance == "mi") {
            data = Number(parseFloat(item.Value * 0.62).toFixed(2));
          } else if (vol == "gal" && distance == "mi") {
            data = Number(parseFloat(item.Value * 2.35).toFixed(2));
          } else if (vol == "gal" && distance == "Km") {
            data = Number(parseFloat(item.Value * 4.54).toFixed(2));
          }
        }

        var obj = {
          y: data,
          name: vehicle.Nick,
          id: item.Key,
        };

        newarr.push(obj);
      });
    } else {
      var obj = {
        y: 0,
        name: "",
        id: "",
      };

      newarr.push(obj);
    }

    return newarr;
  },
  getVehiclesKeys: (state) => (arr) => {
    var v_list = JSON.parse(localStorage.getItem("v_list"));
    var newarr = [];
    if (arr != null && arr.length > 0) {
      if (v_list.length > 0 && v_list != undefined && v_list != null) {
        arr.map((item) => {
          const vehicle = v_list.find(({ MovilId }) => MovilId === item.Key);
          newarr.push(vehicle.Nick);
        });
      }
    } else {
      newarr = arr;
    }

    return newarr;
  },
  performanceArr: (state) => (arr) => {
    var vol =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    var distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    var newarr = [];
    arr.map((item) => {
      //Cambio del sistema de unidades
      var Key = item.Key;
      var keys = Key.split("-");
      var k1, k2;

      if (distance == "Km" && vol == "L") {
        if (Key.includes("-")) {
          Key = Key.replace("-", " - ");
        }
      } else {
        if (distance == "Km" && vol == "gal") {
          k1 = parseFloat(keys[0] * 4.54).toFixed(2);
          k1 = Number(k1);
          k2 =
            keys[1] === undefined
              ? undefined
              : Number(parseFloat(keys[1] * 4.54).toFixed(2));
          k2 = Number(k2);
        } else {
          if (distance == "mi" && vol == "L") {
            k1 = parseFloat(keys[0] * 0.62).toFixed(2);
            k1 = Number(k1);
            k2 =
              keys[1] === undefined
                ? undefined
                : parseFloat(keys[1] * 0.62).toFixed(2);
            k2 = Number(k2);
          } else {
            k1 = parseFloat(keys[0] * 2.35).toFixed(2);
            k1 = Number(k1);
            k2 =
              keys[1] === undefined
                ? undefined
                : parseFloat(keys[1] * 2.35).toFixed(2);
            k2 = Number(k2);
          }
        }

        Key = k2 == undefined ? k1 : k1 + " - " + k2;
      }

      newarr.push([Key, item.Value, false]);
    });
    return newarr;
  },
  exceptionsArr: (state) => (arr) => {
    var newarr = [];
    var sum = 0;
    if (arr != null && arr.length > 0) {
      arr.map((item, index) => {
        if (index < 5) {
          newarr.push([i18n.t("ev" + item.Key), item.Value, false]);
        } else {
          sum += item.Value;
        }
      });
    }
    newarr.push([i18n.t("otros"), sum, false]);
    return newarr;
  },
  validList: (state) => (arr) => {
    var valid = true;
    if (state.vehiclesAggregates.length > 0) {
      state.vehiclesAggregates.forEach((vehicle) => {
        var existingVehicle = arr.find((data) => data === vehicle.MovilId);
        if (
          existingVehicle == undefined ||
          state.vehiclesAggregates.length != arr.length
        ) {
          valid = false;
          return;
        }
      });
    } else {
      valid = false;
    }
    return valid;
  },

  funcionprovisional: (state) => (arr) => {
    var visibleoption = true;
    if (state.vehiclesAggregates.length > 0) {
      state.vehiclesAggregates.forEach((vehicle) => {
        if (vehicle.MovilId == arr.MovilId) {
          visibleoption = false;
          return;
        }
      });
    } else {
      visibleoption = true;
    }
    return visibleoption;
  },

  getOperator: (state) => (value) => {
    var operatorFound = [];
    state.listOperators.forEach((operator) => {
      // console.log(operator);
      if (operator.id == value.id) {
        operatorFound = operator;
        return;
      }
    });
    return operatorFound;
  },

  listTraffic: (state) => (value) => {
    var intravel = 0;
    var noTrip = 0;
    var stopped = 0;
    var outOfService = 0;
    var arr = [];
    value.forEach((traffic) => {
      if (traffic.OperationState == 1) {
        intravel = intravel + 1;
        return;
      }
      if (traffic.OperationState == 2) {
        noTrip = noTrip + 1;
        return;
      }
      if (traffic.OperationState == 3) {
        stopped = stopped + 1;
        return;
      }
      if (traffic.OperationState == 4) {
        outOfService = outOfService + 1;
        return;
      }
    });
    arr = [intravel, noTrip, stopped, outOfService];
    return arr;
  },

  searchOperator: (state) => (value) => {
    var listOperator = JSON.parse(localStorage.getItem("ListOpertator"));
    value.forEach((movil) => {
      Object.assign(movil, {
        Bonding: "N/A",
      });
      listOperator.forEach((operator) => {
        if (operator.Bonding != "N/A") {
          if (operator.Bonding == movil.IMEI) {
            movil.Bonding = operator;
            return;
          }
        } else {
          return;
        }
      });
    });
    return value;
  },
  //orderTrafficList: (state) => (value) => {
  //  var list = [];
  //  value.forEach((vehicle) => {
  //    if (vehicle.status == state.filterTraffic) {
  //      list.push(vehicle);
  //      return;
  //    } else if (state.filterTraffic == i18n.t("allStates")) {
  //      list.push(vehicle);
  //      return;
  //    }
  //  });
  //  return list;
  //},
  AddContacts: (state) => (value) => {
    var contacts = [];
    value.forEach((contact) => {
      var item = {
        Type: contact.type,
        Value: contact.value,
      };
      contacts.push(item);
      return;
    });
    return contacts;
  },
  EditContacts: (state) => (value) => {
    var contacts = [];
    value.forEach((contact) => {
      var icon = "";
      if (contact.Type == 1) {
        icon = "mdi-cellphone";
      } else if (contact.Type == 2) {
        icon = "mdi-email";
      }
      var item = {
        Id: contact.Id,
        icon: icon,
        Type: contact.Type,
        Value: contact.Value,
      };
      contacts.push(item);
      return;
    });
    return contacts;
  },
  EditContactsFull: (state) => (value) => {
    var contacts = [];
    value.forEach((contact) => {
      if (contact.Id != null || contact.Id != undefined) {
        var item = {
          Id: contact.Id,
          Type: contact.Type,
          Value: contact.Value,
        };
        contacts.push(item);
        return;
      } else {
        var item = {
          Type: contact.Type,
          Value: contact.Value,
        };
        contacts.push(item);
        return;
      }
    });
    return contacts;
  },
  addAddress: (state) => (value) => {
    var TrafficList = [];
    var cc = 0;
    if (value.length > 0) {
      value.forEach((traffic) => {
        if (traffic.address != i18n.t("unknown")) {
          var lat = traffic.lat;
          var lng = traffic.lng;
          var latlng = new google.maps.LatLng(lat, lng);
          var ubicacion = "";
          if (cc < 5) {
            cc = cc + 1;
            //var geocoder = (geocoder = new google.maps.Geocoder());
            if (state.errorMaps == false) {
              // geocoder.geocode({ latLng: latlng }, function (results, status) {
              //   if (status == google.maps.GeocoderStatus.OK) {
              //     if (results[1]) {
              //       ubicacion = results[1].formatted_address;
              //       traffic.address = ubicacion;
              //       TrafficList.push(traffic);
              //       return;
              //     }
              //   }
              // });
            } else {
              TrafficList.push(traffic);
              return;
            }
          } else {
            cc = cc + 1;
            TrafficList.push(traffic);
            return;
          }
        } else {
          TrafficList.push(traffic);
          return;
        }
      });
    }
    return TrafficList;
  },

  //formatea las fechas a DD/MMM/YYYY HH:mm, ej. 21/may/2024 10:00 (español) y MMM/DD/YYYY HH:mm, ej. may/21/2024 10:00 (inglés)
  formatDateCustom: (state) => (value) => {
    let formattedDate = "";

    //formato en que llega value (fecha de ws)
    let originalDateFormat = "YYYY-MM-DD HH:mm";

    if (value.includes("T")) {
      originalDateFormat = "YYYY-MM-DDTHH:mm";
    }

    let lang = localStorage.getItem("language");

    //formato que se le dará a la fecha dependiendo del idioma
    let dateFormat = lang == "en" ? "MMM/DD/YYYY HH:mm" : "DD/MMM/YYYY HH:mm";

    //se crea un moment con la fecha recibida y el formato que se le dará a la fecha dependiendo del idioma
    let dateAsMoment = moment(value, originalDateFormat).format();

    if (dateAsMoment === "Invalid date") {
      return value;
    } else {
      formattedDate = moment(dateAsMoment, originalDateFormat).format(dateFormat);
      formattedDate = formattedDate.replace(".", "");
      return formattedDate;
    }
  },

  convertVolume: (state) => (val) => {
    var volFinal = val > 0 ? val : 0;
    var vol =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    if (vol != "L") {
      volFinal = volFinal == 0 ? 0 : parseFloat(volFinal * 0.264172051);
    }
    return parseFloat(volFinal);
  },
  convertDistance: (state) => (val) => {
    var distFinal = val > 0 ? val : 0;
    var distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    if (distance.toUpperCase() != "KM") {
      distFinal = distFinal == 0 ? 0 : parseFloat(distFinal * 0.621371192);
    }

    return parseFloat(distFinal);
  },
  convertPerformance: (state) => (val) => {
    var finalPerformance = val > 0 ? val : 0;
    var vol =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    var distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    if (vol.toUpperCase() == "GAL" && distance.toUpperCase() == "MI") {
      if (finalPerformance != 0) {
        finalPerformance = parseFloat(finalPerformance * 2.35);
      }
    }

    if (vol.toUpperCase() == "GAL" && distance.toUpperCase() == "KM") {
      if (finalPerformance != 0) {
        finalPerformance = parseFloat(finalPerformance * 3.78);
      }
    }

    if (vol.toUpperCase() == "L" && distance.toUpperCase() == "MI") {
      if (finalPerformance != 0) {
        finalPerformance = parseFloat(finalPerformance * 0.62);
      }
    }

    return parseFloat(finalPerformance);
  },
  convertMilesPerHour: (state) => (val) => {
    //0.621371
    var valueFinal = val > 0 ? val : 0;
    var distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    if (distance.toUpperCase() != "KM") {
      valueFinal =
        valueFinal == 0 ? 0 : parseFloat(valueFinal * 0.621371).toFixed(2);
    }

    return parseFloat(valueFinal);
  },
  splitTime: (state) => ({ time }) => {
    return splitTimeFunction.splitFunction(time);
  },
  getProm: (state) => (arr) => {
    var prom = 0;
    var count = 0;
    arr.forEach((element, index) => {
      prom += element;
      count = element == 0 ? count : count + 1;
      if (arr.length - (index + 1) == 0) {
        prom = prom / count;
        prom =
          prom == 0 || isNaN(prom)
            ? 0
            : prom % 1 !== 0
              ? parseFloat(prom).toFixed(2)
              : prom;
      }
    });

    return prom;
  },
  getDaysToMilli: (state) => (val) => {
    var dayInMilli = 86400000;
    val *= dayInMilli;
    return val;
  },

  //Función para validar la latitud y longitud
  isValidLatLon: (state) => (coordinates) => {
    try {
      if ((isFinite(parseFloat(coordinates.lat)) && Math.abs(parseFloat(coordinates.lat)) <= 90) && (isFinite(parseFloat(coordinates.lon)) && Math.abs(parseFloat(coordinates.lon)) <= 180)) return true;
      else return false;

    } catch (e) {
      return false;
    }
  },

  //Función donde se establecen las reglas para validar el valor de DB del campo Reference
  isValidReferenceValue: (state) => (reference) => {
    try {
      if (reference.length >= 5 && reference != "- o -") return true;
        else return false;

    } catch (e) {
      return false;
    }
  },
};
